/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Share_Expires_HoursInputs */

const cs_automation_share_expires_hours = /** @type {(inputs: Automation_Share_Expires_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platnost (hodiny)`)
};

const en_automation_share_expires_hours = /** @type {(inputs: Automation_Share_Expires_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires in (hours)`)
};

/**
* | output |
* | --- |
* | "Expires in (hours)" |
*
* @param {Automation_Share_Expires_HoursInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_share_expires_hours = /** @type {((inputs?: Automation_Share_Expires_HoursInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Share_Expires_HoursInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_share_expires_hours(inputs)
	return cs_automation_share_expires_hours(inputs)
});